// extracted by mini-css-extract-plugin
export default {"portfolio":"style_portfolio__bp5uT","swiper":"style_swiper__WBffC","portfolioSlider":"style_portfolioSlider__wachk","swiper-slide":"style_swiper-slide__296jx"};